module.exports = __webpack_public_path__ + "3ed6db601a253cd04dc27681b1cf957e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/sm_mobile.jpg
// module id = 144
// module chunks = 0